module.exports = __webpack_public_path__ + "static/img/wechat-service.36b373c7.jpg";